import React, { useContext, useEffect, useRef, useState } from "react";
import NavButton from "./NavButton";
import { getApi, PatchApi } from "../../../Utility/network";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import styles from "./Step.module.css";
import "./iframe.css";
import PDFViewer from "../../../Components/PDFViewer/PDFViewer";
import Banner from "../../../Components/CertificateStep7/Banner";
import SidebarValues from "../../../Components/CertificateStep7/SidebarValues";
import ReviewChecklist from "../../../Components/CertificateStep7/ReviewChecklist";
import { needCertificateEngText } from "../../../Utility/engLangObject";
import { needCertificateGerText } from "../../../Utility/gerLangObject";

function Step7(props) {
  const scrollRef = useRef(null);
  const { state, setState } = useContext(AppContext);
  const { language, needLanguage } = state;
  const [pdf, setPdf] = useState({ file: "dummy" });
  const [submitData, setSubmitData] = useState({
    review: [],
    realistic_value: [],
    too_high_value: [],
    feedback_before_final_exhibition: [],
    notes: "",
  });
  const [response, setResponse] = useState(false);
  const [initialLoad, setInitialLoad] = useState(false);

  useEffect(() => {
    getPdfId();
    window.scroll(0, 0);
  }, []);

  // Sync local review data to context to restore when navigating back
  useEffect(() => {
    setState((prev) => ({
      ...prev,
      review: submitData.review,
      realistic_value: submitData.realistic_value,
      too_high_value: submitData.too_high_value,
      feedback_before_final_exhibition: submitData.feedback_before_final_exhibition,
      notes: submitData.notes,
    }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submitData]);

  useEffect(() => {
    if (initialLoad) return;
    if (state?.review) {
      setSubmitData({
        review: state.review || [],
        realistic_value: state.realistic_value || [],
        too_high_value: state.too_high_value || [],
        feedback_before_final_exhibition: state.feedback_before_final_exhibition || [],
        notes: state.notes || "",
      });
      setInitialLoad(true);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.review]);

  useEffect(() => {
    if (!state?.needId) return;
    if (initialLoad) return;
    const fetchSaved = async () => {
      try {
        const res = await getApi(
          `/energy_need/additional_information?energy_need=${state.needId}&page_no=7`
        );
        const list = res?.data?.data || res?.data || [];
        const item = Array.isArray(list) ? list[0] : null;
        if (item?.review_data || item?.notes) {
          try {
            let parsed = item?.review_data ? item.review_data : (item?.notes ? item.notes : {});
            if (typeof parsed === 'string') {
              try {
                parsed = JSON.parse(parsed);
                // Handle double stringified JSON from Django JSONField
                if (typeof parsed === 'string') {
                  parsed = JSON.parse(parsed);
                }
              } catch (e) { }
            }
            setSubmitData((prev) => ({
              ...prev,
              realistic_value: Array.isArray(parsed?.realistic_value)
                ? parsed.realistic_value
                : [],
              too_high_value: Array.isArray(parsed?.too_high_value)
                ? parsed.too_high_value
                : [],
              feedback_before_final_exhibition: Array.isArray(
                parsed?.feedback_before_final_exhibition
              )
                ? parsed.feedback_before_final_exhibition
                : [],
              notes: parsed?.notes || (typeof parsed === "string" ? parsed : ""),
            }));
          } catch (e) {
            // ignore malformed JSON
          }
        }
      } catch (e) {
        // ignore fetch errors
      } finally {
        setInitialLoad(true);
      }
    };
    fetchSaved();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state?.needId]);

  const getPdfId = async () => {
    try {
      const postEnergy = await getApi(
        `energy_need/${state.needId}/calculate_energy_consumption/`
      );
      if (postEnergy.status === 200) {
        const generate_pdf = await getApi(
          `records/energy_need/${postEnergy?.data?.data?.id}/generate_energy_need_certificate/`
        );
        if (generate_pdf.status === 200 || generate_pdf.status === 201) {
          getData(postEnergy?.data?.data?.id);
        }
      }
    } catch (error) {}
  };

  const getData = async (id) => {
    try {
      const responseData = await getApi(
        `/records/energy_need/${id}/generate_energy_need_certificate/`
      );
      setPdf(responseData.data?.data);
    } catch (error) {}
  };

  const handleSubmit = async (num, type) => {
    try {
      const payload = {
        page_no: 7,
        review_data: {
          realistic_value: submitData.realistic_value,
          too_high_value: submitData.too_high_value,
          feedback_before_final_exhibition: submitData.feedback_before_final_exhibition,
          notes: submitData.notes,
        },
      };
      await PatchApi(
        `/energy_need/${state.needId}/additional_information/`,
        payload
      );
    } catch (e) {
      console.log(e);
    }

    if (type === "next") {
      setState((prev) => ({
        ...prev,
        needPage: 8,
        needFilledPage: prev.needFilledPage >= 8 ? prev.needFilledPage : 8,
      }));
    } else if (type === "save") {
      setResponse(true);
    } else if (type === "prev") {
      setState((prev) => ({ ...prev, needPage: prev.needPage - 1 }));
    }
  };

  const handleCheckboxChange = (name, checkedIds) => {
    if (name === "review") {
      setSubmitData((prev) => ({ ...prev, review: checkedIds }));
    } else if (name === "realistic_value") {
      setSubmitData((prev) => ({ ...prev, realistic_value: checkedIds }));
    } else if (name === "too_high_value") {
      setSubmitData((prev) => ({ ...prev, too_high_value: checkedIds }));
    } else if (name === "feedback_before_final_exhibition") {
      setSubmitData((prev) => ({
        ...prev,
        feedback_before_final_exhibition: checkedIds,
      }));
    }
  };

  const handleClick = () => {
    if (scrollRef.current) {
      scrollRef.current.scrollIntoView({
        behavior: "smooth",
        block: "start",
      });
    } else {
      console.log("scrollRef.current is null");
    }
  };

  const handleChangeNotes = (event) => {
    const { value } = event.target;
    setSubmitData((prev) => ({ ...prev, notes: value }));
  };

  return (
    <div className={styles.step7}>
      <Banner styles={styles} language={needLanguage} onContinue={handleClick} />
      <div className={styles.grid}>
        <div className={styles.panel}>
          {pdf && pdf.file !== "" && pdf?.file && (
            <div className={styles.doc}>
              <PDFViewer _url={pdf?.file} />
            </div>
          )}
          <div style={{ marginTop: "14px" }} className={styles.small}>
            {needLanguage.energy_certificate_available_pdf_check_your_details}
          </div>
          <div className={styles.progress}>
            <div className={styles.bar}></div>
          </div>
          <div className={styles.small} style={{ marginTop: "6px" }}>
            {needLanguage.energy_certificate_available_pdf_progress_bar}
          </div>
        </div>

        <div className={styles.panel}>
          <h3 style={{ margin: "0 0 10px" }}>
            {needLanguage.energy_certificate_available_pdf_sidebar_section_1_title}
          </h3>
          <div className={styles.benefits}>
            <div className={styles.benefit}>
              <p>
                {needLanguage.energy_certificate_available_pdf_sidebar_section_1_check_1}
              </p>
            </div>
            <div className={styles.benefit}>
              <p>
                {needLanguage.energy_certificate_available_pdf_sidebar_section_1_check_2}
              </p>
            </div>
            <div className={styles.benefit}>
              <p>
                {needLanguage.energy_certificate_available_pdf_sidebar_section_1_check_2}
              </p>
            </div>
            <div className={styles.benefit}>
              <p>
                {needLanguage.energy_certificate_available_pdf_sidebar_section_1_check_3}
              </p>
            </div>
          </div>

          <hr
            style={{
              border: "none",
              borderTop: "1px solid #e5e7eb",
              margin: "18px 0",
            }}
          />
          <SidebarValues
            styles={styles}
            labels={{
              title: needLanguage.energy_certificate_available_pdf_sidebar_section_2_title,
              para1: needLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_1,
              para2: needLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_2,
              para3: needLanguage.energy_certificate_available_pdf_sidebar_section_2_para_part_3,
              info: needLanguage.energy_certificate_available_pdf_sidebar_section_2_info,
              feedbackLabel: needLanguage.energy_certificate_available_pdf_sidebar_section_2_feedback,
            }}
            checkboxData={[
              {
                name: "realistic_value",
                data: [
                  {
                    title:
                      needCertificateEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_1,
                    german_title:
                      needCertificateGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_1,
                    id: 2,
                  },
                ],
                selectedValues: submitData.realistic_value,
              },
              {
                name: "too_high_value",
                data: [
                  {
                    title:
                      needCertificateEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_2,
                    german_title:
                      needCertificateGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_2,
                    id: 3,
                  },
                ],
                selectedValues: submitData.too_high_value,
              },
              {
                name: "feedback_before_final_exhibition",
                data: [
                  {
                    title:
                      needCertificateEngText.energy_certificate_available_pdf_sidebar_section_2_checkbox_3,
                    german_title:
                      needCertificateGerText.energy_certificate_available_pdf_sidebar_section_2_checkbox_3,
                    id: 4,
                  },
                ],
                selectedValues: submitData.feedback_before_final_exhibition,
              },
            ]}
            handleCheckboxChange={handleCheckboxChange}
            notes={submitData.notes}
            handleChangeNotes={handleChangeNotes}
          />
        </div>
      </div>

      <ReviewChecklist
        styles={styles}
        refProp={scrollRef}
        data={language === "en" ? data : dataGerman}
        selectedValues={submitData.review}
        handleCheckboxChange={handleCheckboxChange}
      />
      <NavButton
        handleSubmit={handleSubmit}
        disabled={submitData?.review?.length > 0 ? false : true}
        response={response}
      />
    </div>
  );
}

export default Step7;

const data = [
  {
    title: needCertificateEngText.i_reviewed_entries,
    german_title: needCertificateGerText.i_reviewed_entries,
    id: 1,
  },
];

const dataGerman = [
  {
    title: needCertificateGerText.i_reviewed_entries,
    id: 1,
  },
];
